// extracted by mini-css-extract-plugin
export default {"question":"Money_question__wfmWZ","invalidName":"Money_invalidName__pj5To","blink":"Money_blink__Oj8Jf"};